<template>
    <div class="flex justify-end mr-0 w-auto mt-4 flex-shrink-0" v-if="showUI">
        <transition
        enter-active-class="transition-all transform duration-300 ease-out"
        leave-active-class="transition-all transform duration-300 ease-out"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
        >
        <div class="flex items-center" v-if="isBlockHovered && !showMediaHistoryBlock">
            <div class="text-white bg-blue-dark rounded px-4 py-2 mr-4 ">
            Derniers documents
            </div>
        </div>
        </transition>
        <div 
            class="media-history faa-fade faa-opti" 
            :class="{ 'faa-fade-in': ready && show }"
            @mouseover="isBlockHovered = true"
            @mouseleave="isBlockHovered = false"
        >
            <div class="flex justify-end">
                <!-- Hide/Close Profil Icon -->
                <div class="left-0 bg-white-o7 rounded-full shadow-dark w-10 h-10 p-4 mr-4 cursor-pointer"
                    v-if="showMediaHistoryBlock"
                    @click="showMediaHistoryBlock = false, isBlockHovered = false"
                >
                    <img src="@/assets/images/close-icon.svg">
                </div>

                <!-- Media history -->
                <div
                class="media-history-block bg-blue rounded-l-md shadow-dark py-2 px-6"
                :class="{ 'shown': showMediaHistoryBlock, 'cursor-pointer':  (mediaHistory.length > 0 || !showMediaHistoryBlock) }"
                @click="(showMediaHistoryBlock ? toggleDetails() : showMediaHistoryBlock = true)">
                    <table class="text-xs uppercase w-full h-full">
                        <!-- Header -->
                        <tr>
                            <th class="flex items-center align-middle text-white text-lg cursor-pointer h-full">
                                <img class="h-6" src="@/assets/images/folder-icon.svg" @load="loaded">
                                <p class="ml-4" v-show="mediaHistory.length > 0 && showMediaHistoryBlock">{{mediaHistory.length}}</p>
                            </th>

                            <th class="text-right" 
                            v-show="mediaHistory.length > 0 && showMediaHistoryBlock">
                                <img
                            class="inline w-4"
                            src="@/assets/images/arrow-down-white-icon.svg"
                            :class="{
                                'transform rotate-180': showDetails
                            }">
                            </th>
                        </tr>
                    </table>
                </div>
            </div>

            <!-- List -->
            <div class="media-history-list" v-show="showDetails && mediaHistory.length > 0">
                <table>
                    <tbody>
                        <tr
                        v-for="(history, index) in mediaHistory"
                        :key="index">
                            <td>
                                <div
                                class="cursor-pointer"
                                @click="mediaClick(history)">
                                    <span>
                                        {{history.data.node_title}}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'TheMediaHistory',
        data() {
            return {
                // UI states
                ready: false,
                show: false,
                showMediaHistoryBlock: false,
                showDetails: false,
                isBlockHovered: false,
                // Data states
                results: [true, true, true, true, true, true, true, true],
                visitedMediaLibrary: false,
                locationResults: [
                    {
                        value: -1,
                        name: "Administrateur chevronné",
                        slugs: ['expert_house'],
                    }, 
                    {
                        value: -1,
                        name: "Office Public de l'Habitat",
                        slugs: ['oph_ca', 'oph_dg', 'oph_dgl', 'oph_caleol', 'oph_daf'],
                    }, 
                    {
                        value: -1,
                        name: "Site en chantier",
                        slugs: ['construction_site'],
                    },
                    {
                        value: -1,
                        name: "Mairie",
                        slugs: ['town_hall'],
                    },
                ]
            }
        },
        computed: {
            ...mapState('Logs', [ 'media_history' ]),
            ...mapState('Assets', {
                assets(state) {
                    if (!state.list || state.list.length <= 0)
                        return {}

                    return state.list.reduce((dict, asset) => {
                        dict[asset.id] = asset

                        return dict
                    }, {})
                }
            }),
            showUI() {
                return (this.$route.meta && this.$route.meta.showUI);
            },
            mediaHistory() {
                return this.media_history.slice(0, 6)
            },
        },
        watch: {
            showUI: {
                handler(show) {
                    setTimeout(() => {
                        this.show = show
                    }, 250)
                },
                immediate: true,
            },
            showMediaHistoryBlock: {
                handler(show) {
                    if (!show) {
                        this.showDetails = false
                        this.$emit('closing')
                    } else {
                        this.$emit('opening')
                        this.showDetails = true
                    }
                },
                immediate: true,
            },
            $route: {
                handler(to) {
                    // todo improve
                    // Update content when going to home page
                    if (to.name == 'Home') {
                        this.loaded()
                    }
                },
                immediate: true,
            }
        },
        methods: {
            async loaded() {
                this.ready = false

                // Load media history
                await this.$store.dispatch('Logs/loadMediaHistory')

                // Load assets list if needed
                if (this.$store.state.Assets.list.length <= 0) {
                    await this.$store.dispatch('Assets/getList')
                }
                
                this.ready = true
            },
            toggleDetails() {
                if (this.mediaHistory.length <= 0)
                    return

                this.showDetails = !this.showDetails
            },
            async mediaClick(log) {
                const asset = this.assets[log.data_key]
                
                asset.title = log.data.node_title

                this.$emit('show-asset', asset)
            },
            close() {
                this.showMediaHistoryBlock = false
            },
        }
    }
</script>

<style lang="scss" scoped>

.media-history {
    &-block {
        overflow: hidden;
        transition: width .3s;
        width: 5rem;
        height: 3rem;

        &.shown {
            width: 17rem;
        }

        &-content {
            width: 14rem;
        }
    }

    &-list {

        table {
            width: 15rem;
            margin-left: auto;
            margin-right: 2rem;
        }

        td {
            div {
                @apply text-left text-sm bg-white rounded-md shadow-dark py-2 px-6 mt-2;
            }
        }
    }
}

</style>
